import axios from "axios";

// Obtener la URL base desde .env
const API_URL =
  process.env.REACT_APP_API_URL || "https://api.fichajedigital.com/api/";
const userData = await localStorage.getItem("userData");
// Crear instancia de Axios con la URL base
const axiosApi = axios.create({
  baseURL: API_URL, // ✅ Todas las llamadas usarán esta URL por defecto
});
// Request interceptor for API calls
axiosApi.interceptors.request.use(
  async (config) => {
    if (!localStorage.getItem("token")) {
      return;
    }
    console.log("Request URL:", config.url);
    console.log("Headers:", config.headers);
    config.headers = {
      Authorization: `Bearer ` + localStorage.getItem("token"),
      Accept: "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
      // // 'Access-Control-Allow-Origin': '*',
      // 'Access-Control-Request-Private-Network': 'true',
      // 'Access-Control-Allow-Headers':'Origin,Authorization, Content-Type, X-Auth-Token,X-Requested-With',
    };
    console.log("Headers:", config.headers);
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApi.interceptors.response.use(
  (response) => {
    // console.log('axios response' , response)

    if (response.data.nuevotoken) {
      // console.log('viene token nuevo lo actualizamos')
      localStorage.setItem("token", response.data.nuevotoken);
    }
    return response;
  },
  (error) => {
    console.log(error.response, error.request);
    if (error.response.status === 401) {
      // window.alert('401')
      console.log("Token expirado?");
      localStorage.removeItem("usuario");
      localStorage.removeItem("token");
      localStorage.clear();
      // Pendiente de comprobar token expirado
      window.location.reload();
    }
    if (error.response.status === 403) {
      console.log("403", window.location.hostname);
      localStorage.clear();
      // window.alert("No estás autorizado a acceder a esta información");
      window.location.replace("/login");
      // return "403";
      //  localStorage.removeItem("usuario");
      //  localStorage.removeItem("token");
      // Pendiente de comprobar token expirado
      //  window.location.reload()
      return Promise.reject(error);
    }
    if (error.response.status === 400) {
      console.error("Error 400 - Solicitud mal formada:", error.response.data);
      return Promise.reject(error); // Permite que el error sea manejado donde se realizó la solicitud
    }
    if (error.response.status === 500 || error.response.status === 400) {
      console.log("400 ó 500");
      return Promise.reject(error);
      //  localStorage.removeItem("usuario");
      //  localStorage.removeItem("token");
      // Pendiente de comprobar token expirado
      //  window.location.reload()
    }
    return Promise.reject(error);
    // Promise.reject(error)
    return error;
  }
);

const exported = {
  axiosApi,
};

export default axiosApi;
